import styled from 'styled-components';
import {Space} from 'antd';
import {typographyStyles} from '../../../../../utils/styles';

const StyledExpenseDetailsTab = styled.div`
  width: 100%;
`;

const StyledExpenseDetailsTabFooter = styled.footer`
  align-items: center;
  background-color: ${props => props.theme.colors.neutral_1};
  border-top: 1px solid ${props => props.theme.colors.neutral_3};
  bottom: 0;
  justify-content: space-between;
  display: flex;
  left: 0;
  padding: 20px 24px;
  position: sticky;
  width: 100%;

  .ant-btn {
    align-items: center;
    display: inline-flex;
    justify-content: center;
    width: calc(50% - 8px);

    svg {
      transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      height: 16px;
      width: 16px;
    }

    &.ant-btn-default {
      svg {
        path {
          fill: ${props => props.theme.colors.neutral_10};
        }
      }
      &:hover {
        svg {
          path {
            fill: ${props => props.theme.colors.primary_5};
          }
        }
      }
    }

    &.ant-btn-primary {
      svg {
        path {
          fill: ${props => props.theme.colors.neutral_1};
        }
      }
    }
  }
`;

const StyledExpenseDetailsTabSpace = styled(Space)`
  margin-bottom: 16px;
  width: 100%;

  .ant-card-head {
    background-color: ${props => props.theme.colors.neutral_2};
    border-color: ${props => props.theme.colors.neutral_4};
  }
`;

const StyledExpenseDetailsTabPrice = styled.div`
  ${typographyStyles.heading.h3};
  color: ${props => props.theme.colors.neutral_10};
`;

export {
  StyledExpenseDetailsTab,
  StyledExpenseDetailsTabSpace,
  StyledExpenseDetailsTabPrice,
  StyledExpenseDetailsTabFooter,
}
